// Información legal pública del prestador. Axios plano + apiUrl, no apiAxios:
// el interceptor de apiAxios agrega un JWT de localStorage y fuerza un redirect
// a /login ante cualquier 401 - comportamiento incorrecto para una pantalla sin
// sesión (mismo criterio que api/videoconsultaEnlacePublico.js).
import axios from 'axios';
import { apiUrl } from '../utils/constants';

// Las dos casillas del apartado IX.A.1 de la Norma General Técnica N° 237: una
// para ejercer los derechos de acceso, rectificación y portabilidad, y otra para
// comunicar incidentes de seguridad. Vienen del backend (variables de entorno
// del despliegue) y no de esta pantalla, porque son del prestador institucional
// y cambian por despliegue. Cualquiera de las dos puede venir en null; en ese
// caso no se muestra.
export const getContactosPublicos = () => {
    return axios.get(`${apiUrl}legal/contactos`);
}

// El aviso de privacidad del apartado IX.B.3.c de la misma norma: qué
// información se trata, de dónde viene, con qué fundamento, dónde se guarda,
// quién más la recibe y por cuánto tiempo. El texto vive en el backend
// (aviso_privacidad_service.py) y viene versionado, igual que los textos de
// consentimiento: lo que la persona lee y lo que el sistema declara tienen que
// ser el mismo texto.
export const getAvisoPrivacidad = () => {
    return axios.get(`${apiUrl}legal/aviso-privacidad`);
}
